
import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import LoaderSpinner from "~/components/LoaderSpinner.vue";
import Validation from "~/entities/Validation";
import ValidationQBP from "~/entities/ValidationModules/ValidationQBP";

export default Vue.extend({
  name: "QBPtopshop",
  components: { LoaderSpinner },
  data() {
    return {
      title: "QBP Top Shop",
      submited: false,
      qbpData: {},
      response: false,
      error: false,
      validation: new Validation(new ValidationQBP()),
      requestError: null as null | undefined | any,
      phone: "",
      email: "",
      ownerName: "",
      businessName: "",
    };
  },
  head() {
    return {
      title: this.title,
    };
  },
  computed: {
    // Vuex getters
    ...mapGetters({
      loading: "loading",
      activeNotices: "errorsBag/activeNotices" as any,
      alertResponses: "errorsBag/alertResponses" as any,
    }),
  },
  async mounted() {
    (this as any).submited = false;
    (this as any).error = false;
    (this as any).validation.module.component = this;
  },
  methods: {
    ...mapMutations({
      setPackageLocation: "setPackageLocation",
      setLoading: "setLoading",
    }),
    ...mapActions({
      requestAlert: "errorsBag/requestAlert",
      clearActiveNotices: "errorsBag/clearActiveNotices",
      clearAlertResponses: "errorsBag/clearAlertResponses",
      removeNotice: "errorsBag/removeNotice",
      addNotice: "errorsBag/addNotice",
      postQBPTopShop: "postQBPTopShop",
    }),
    async submit() {
      try {
        (this as any).error = false;
        this.submited = true;
        if ((this as any).validation.Validate()) {
          this.submited = true;
          this.response = await (this as any).postQBPTopShop({
            businessName: this.businessName,
            ownerName: this.ownerName,
            processed: true,
            email: this.email,
            phone: this.phone,
            dateSubmitted: new Date(),
          });
          if (!this.response) {
            this.requestError = true;
          } else {
          }
        } else {
          (this as any).error = true;
          this.response = false;
        }
      } catch (e) {
        this.response = false;
        (this as any).error = true;
        this.resetSubmit();
      }
    },
    resetError() {
      this.error = false;
      this.submited = false;
    },
    resetSubmit() {
      this.submited = false;
    },
  },
});
